module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-6_BW-p-1080-9d9eb5a85066056c17db1d5cd7040cdb.jpg";